var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dateExplain"},[_c('p',[_vm._v("*以上视图与表格内数据仅为根据您输入的查询条件查询后展示的结果 ")])])}]

export { render, staticRenderFns }